(function ($, global, _) {

  _.UI.extend('Lazyload', {
    init: function (el, options) {
      var me = this;
      me.base(el, options);
      me.opt = $.extend({}, _.Lazyload.defaultOptions, me.opt);
      /*me.$w = $(window);
      me.calcSize(true);*/
      //me.wraps = $('img');
      this.temp();
     /* me.needLoadCount = me.wraps.length;
      me.loadedCount = 0;
      me.bindAction();
      me.scrollTimer = setTimeout(function () {
        me.calcSize(true);
        me.update();
      }, 100);*/
    },
    temp:function(){
      var me = this;
      this.loadImg($('img'));
      $(document.body).bind('appendHtml', function (e, html) {
        me.loadImg($(html).find('img'));
      });
    },
    loadImgTimer:null,
    loadImg: function ($wrap) {
      var me = this, $imgs = $wrap;
      $wrap.attr('lazyload-loaded', 'loaded');
      $imgs.each(function (i, img) {
        var $img = $(img);
        //包含占位符图片的才是需要延迟加载的
        if (~img.src.toLowerCase().indexOf(me.opt.placeholderName)) {
          $img
            .addClass('img-placeholder')
            .load(function () {
              $img.removeClass('img-placeholder');
            	clearTimeout(me.loadImgTimer);
            	me.loadImgTimer =  setTimeout(function(){
                $(document.body).trigger('imgLoaded');
              },500);
            })
            .attr('src', $img.attr('data-src'));
        }
      });
    },
    update: function () {
      /// <summary>
      /// 根据当前屏幕位置更新需要加载的图片地址
      /// </summary>
      var me = this;
      if (me.needLoadCount !== me.loadedCount) {
        me.wraps.each(function (i, wrap) {
          $wrap = $(wrap);
          var position = me.calcPosition($wrap, me.opt.preloadHeight);
          if (!position.below && !position.above && $wrap.attr('lazyload-loaded') !== 'loaded') {
            me.loadedCount++;
            me.loadImg($wrap);
          }
        });
      }
      else {
        //全部加载完了,则移除多余的事件监听
        me.$w.unbind('resize', me.onResize).unbind('scroll', me.onScroll);
      }
    },
    calcSize: function (calcHeight) {
      /// <summary>
      /// 计算可视区域高度，滚动条高度
      /// </summary>
      /// <param name="calcHeight">是否计算可视区域高度,只有首次加载和改变页面尺寸时,才需重新计算</param>
      if (calcHeight) {
        this.wHeight = this.$w.height();
      }
      this.scrollTop = this.$w.scrollTop();
      this.screenHeight = this.wHeight + this.scrollTop;
    },
    
    bindAction: function () {
      var me = this;
      //这两个函数在这里定义,是为了得到this引用.
      me.onResize = function () {
        clearTimeout(me.resizeTimer);
        me.resizeTimer = setTimeout(function () {
          me.calcSize(true);
          me.update();
        }, 500);
      };

      me.onScroll = function () {
        //使用定时器,这样在连续滚动时,只有停止滚动才会真正的加载
        clearTimeout(me.scrollTimer);
        me.scrollTimer = setTimeout(function () {
          me.calcSize();
          me.update();
        }, 100);
      };

      me.$w.bind('resize',me.onResize).bind('scroll',me.onScroll);
      //异步加载的html片段,要手动触发body的自定义事件appendHtml,并且将插入的html碎片作为参数.
      $(document.body).bind('appendHtml', function (e, html) {
        me.loadImg($(html).find('img'));
      });
    },
    //判断一个元素在页面可是区域的之下或者之上,两者都不是,则该元素在视野内.
    calcPosition: function ($el, preloadHeight) {
      var top = $el.offset().top,
        below = this.screenHeight <= top - preloadHeight,
        above = this.scrollTop >= top + $el.height() + preloadHeight;
      return {
        below: below,
        above:above
      };
    }
  });

  _.Lazyload.defaultOptions = {
    //预加载高度（px），即下一屏的高度<可视区域高度+preloadHeight时加载
    preloadHeight: 1000,
    //占位符图片名称,只有图片地址包含此名称的img才会延迟加载，否则都视为已加载完毕
    placeholderName: 'lazyloadplaceholder.gif'
  };
})(jQuery, this, ue);